export const changeUser = payload => ({
  type: 'CHANGE_USER',
  payload,
})

export const changeMetricUnit = payload => ({
  type: 'CHANGE_METRIC_UNIT',
  payload,
})